module.exports = __webpack_public_path__ + "resources/img/img_magic_sso_m.28042d92ada174e06d079b84c6e7552c.png";